import letters from '../../constants/groupLetters.json';
const generateGroupBoard = (g, teams) => {
    let board = null;
    if (g > 0) {
        board = {
            columnsId: [],
            columns: {}
        };
        const k = teams.length / g;

        let i = 1;
        let cards = [];
        for (let j = 1; j <= teams.length; j++) {
            const team = teams[j - 1];
            cards.push({
                id: team.uid,
                title: team.title,
                logoUrl: team.logoUrl
            });

            if (j + 1 > k * i) {//  new group column
                const columnId = 'group_' + letters[i - 1];
                board.columns[columnId] = {
                    id: columnId,
                    title: "Grupo " + letters[i - 1],
                    cards: cards
                };
                board.columnsId.push(columnId)
                cards = [];
                i++;
            }
        }

        // }
    }
    return board;
}

const generateEliminationBoard = (teams) => {
    let board = null;
    if (teams.length > 0) {
        board = {
            columnId: 'column',
            column: {}
        };

        let cards = [];
        for (let i = 1; i <= teams.length; i++) {
            const team = teams[i - 1];
            cards.push({
                id: team.uid,
                title: team.title,
                logoUrl: team.logoUrl
            });
        }
        board.column = {
            id: 'column',
            title: 'Eliminatoria',
            cards: cards
        };
    }
    return board;
}

const getTeamWinnerUid = (match, result) => {
    if (result) {
        if (result.goalsA != null && result.goalsB != null) {
            if (result.goalsA > result.goalsB) {
                return match.teamA;
            }
            if (result.goalsA < result.goalsB) {
                return match.teamB;
            }
            if (result.goalsA === result.goalsB) {
                if (result.penaltiesA != null && result.penaltiesB != null) {
                    if (result.penaltiesA > result.penaltiesB) {
                        return match.teamA;
                    }
                    if (result.penaltiesA < result.penaltiesB) {
                        return match.teamB;
                    }
                }
            }
        }
    }
    return null;
}

export { generateGroupBoard, generateEliminationBoard, getTeamWinnerUid };


